<script setup>
import ElectronicInvoiceGrid from '@/components/sale/ElectronicInvoiceGrid.vue'

</script>
<template>
  <electronic-invoice-grid />
</template>
